import {
  InstantAnswerBuilderFn,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const BrandResponsibility: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: () => brandResponsibilityBuilder(strictLocalize).getTitle(),
  descriptionBuilder: () =>
    brandResponsibilityBuilder(strictLocalize).getDescription(),
});

const brandResponsibilityBuilder = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () =>
      strictLocalize({
        defaultMessage: "International shipping regulations",
        description: {
          text: "Title for the answer of brand's responsibility issue",
        },
      }),
    getDescription: () => [
      strictLocalize({
        defaultMessage:
          "All brands selling on Faire are responsible for complying with all laws, rules, and regulations in all countries and regions they choose to sell their products in on Faire.",
      }),
      strictLocalize({
        defaultMessage:
          "This includes but is not limited to: product safety, labeling requirements, testing, warnings, copyright, import/export regulations, and other consumer protection law requirements.",
      }),
      strictLocalize({
        defaultMessage:
          "To determine if your products can be sold in other countries or regions, please consult a customs broker or legal counsel.",
      }),
    ],
  };
};
